<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <footer class="the-footer flex-wrap justify-center" :class="classes">
        <p>
            <span class="text-sm">v{{ version }}</span>
        </p>
    </footer>
</template>

<script>
import { version } from "@/../package.json"

export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        }
    },
    data() {
        return {
            version
        }
    }
}
</script>
